export const ALPHA_NUMERIC = /^[0-9a-zA-Z]+$/;
export const HOME_PRICE = /^(.{0}|\d{0,7}|\d{0,7}\.\d{0,2})$/;
export const ASSETS_PRICE = /^(.{0}|\d{0,6}|\d{0,6}\.\d{0,2})$/;
export const PHONE = /^(.{0}|\d{0,9})$/;

export const minMaxLengthAlphanumericRegex = (minLength, maxLength) => {
    return new RegExp(`^[a-zA-Z0-9]{${minLength},${maxLength}}$`, "i");
};

export const isNull = (value, defaultValue = "") => {
    return value === null || value === undefined ? defaultValue : value;
};

export const ONLY_NUMBERS = /^[0-9]+$/;
